// Notes that two people edit at once (DATA-03 / ROLES-12): an edit made from an older text (`base`) is replayed onto
// the newer stored text (`theirs`) instead of overwriting it. Pure functions — no store, no DOM (unit-tested).

// The one changed region of `next` against `base`: base[start, end) was replaced by `text`.
export function editOf(base, next) {
  const max = Math.min(base.length, next.length);
  let p = 0;
  while (p < max && base[p] === next[p]) p += 1;
  let q = 0;
  while (q < max - p && base[base.length - 1 - q] === next[next.length - 1 - q]) q += 1;
  return { start: p, end: base.length - q, text: next.slice(p, next.length - q) };
}

// mine and theirs both started from base. Non-overlapping edits are both kept (theirs first when they touch, e.g. two
// lines appended at the end); overlapping edits keep their text and add what I typed on a new line below — nothing lost.
export function mergeNotes(base, mine, theirs) {
  if (mine === base || mine === theirs) return theirs;
  if (theirs === base) return mine;
  const m = editOf(base, mine);
  const t = editOf(base, theirs);
  if (t.end <= m.start) {
    // Both typed at the same spot (e.g. after the last line): keep the two texts on separate lines.
    const same = t.start === t.end && m.start === m.end && t.end === m.start;
    const sep = same && !t.text.endsWith('\n') && !m.text.startsWith('\n') ? '\n' : '';
    return base.slice(0, t.start) + t.text + base.slice(t.end, m.start) + sep + m.text + base.slice(m.end);
  }
  if (m.end <= t.start) return base.slice(0, m.start) + m.text + base.slice(m.end, t.start) + t.text + base.slice(t.end);
  if (!m.text.trim()) return theirs;
  return `${theirs}${theirs && !theirs.endsWith('\n') ? '\n' : ''}${m.text.replace(/^\n+/, '')}`;
}

// Is my edit (base → mine) already part of theirs? (A draft whose save landed before someone else edited again.)
export function containsEdit(base, mine, theirs) {
  if (mine === theirs) return true;
  const m = editOf(base, mine);
  if (m.text) return theirs.includes(m.text);
  return !theirs.includes(base.slice(m.start, m.end));
}
